module.exports = __webpack_public_path__ + "static/img/button_digita_active.263f893a.png";